__turbopack_context__.v({
  "buttonGroup": "PopupBody-module__2f3G-q__buttonGroup",
  "popup": "PopupBody-module__2f3G-q__popup",
});
